import { put, takeLatest } from 'redux-saga/effects'

import { common, error, stripe } from '../constants/actions'
import { stripe as stripeEndpoints } from '../constants/endpoints'
import { get, post } from '../utils/request'

export function* postCreatePaymentIntent(action) {
  const { payload } = action
  const { orderId } = payload

  if (!orderId) {
    yield put(stripe.setPaymentIntent(null))
    yield put(common.setShowLoadingIndicator(false))
    return
  }

  yield put(common.setShowLoadingIndicator(true))

  const response = yield post({
    endpointId: stripeEndpoints.createPaymentIntent,
    data: {
      orderId,
    },
  })

  if (response.success && response.data) {
    yield put(stripe.setPaymentIntent(response.data))
    yield put(common.setShowLoadingIndicator(false))

    return
  }

  yield put(
    error.onPaymentPageError({
      title: 'Error',
      description:
        'An error occurred while initialising Stripe payment gateway. Please select an alternate payment method, or try again later.',
    })
  )

  yield put(common.setShowLoadingIndicator(false))
}

export function* getPaymentStatus(action) {
  const { payload } = action
  const { paymentIntent } = payload

  if (!paymentIntent) {
    yield put(common.setShowLoadingIndicator(false))
    return
  }

  yield put(common.setShowLoadingIndicator(true))

  const response = yield get({
    endpointId: stripeEndpoints.getPaymentStatus,
    params: {
      paymentIntent,
    },
  })

  if (response.success && response.data) {
    yield put(stripe.setPaymentStatus(response.data))
    yield put(common.setShowLoadingIndicator(false))

    return
  }

  yield put(common.setShowLoadingIndicator(false))
}

export function* runStripeSagas() {
  yield takeLatest(stripe.CREATE_PAYMENT_INTENT, postCreatePaymentIntent)
  yield takeLatest(stripe.GET_PAYMENT_STATUS, getPaymentStatus)
}
